import { configureStore } from "@reduxjs/toolkit";
import appReducer from './appSlice';
import notificationReducer from './components/NotificationStack/notificationSlice';
import userReducer from './state/userSlice';
import itemDisplayReducer from './components/ItemDisplay/itemDisplaySlice';
import locationReducer from './state/locationSlice';

export const store = configureStore({
    reducer: {
        app: appReducer,
        notifications: notificationReducer,
        user: userReducer,
        itemDisplay: itemDisplayReducer,
        location: locationReducer
    }
});

export type RootState = ReturnType<typeof store.getState>